import axios from 'axios';
import env from '../env';
import { DebugToken } from '../types/DebugToken';
import poliApiGatewayRequest from 'src/utils/poliApiGatewayRequest';

const getWabasFromDebugToken = async (
  token: string,
  requestFromWabaService: boolean
): Promise<string[] | undefined> => {
  try {
    var response;
    if(requestFromWabaService){
      const url = `/waba/token/${token}`;
      response = await poliApiGatewayRequest.get(url);
    } else {
      response = await axios.get(
        `https://graph.facebook.com/v14.0/debug_token?input_token=${token}&access_token=${env.SYSTEM_USER_ACCESS_TOKEN}`
      );
    }

    const data: DebugToken | undefined = response?.data?.data;
    if (!data) {
      console.error('getWabasFromDebugToken: No data returned from API');
      return undefined;
    }

    const foundScopeWBM = data.granular_scopes?.find((e) => {
      return e.scope === 'whatsapp_business_management';
    });

    if (foundScopeWBM && foundScopeWBM.target_ids) {
      console.log(`Found ${foundScopeWBM.target_ids.length} WABA(s) for token`);
      return foundScopeWBM.target_ids;
    } else {
      console.error(
        'getWabasFromDebugToken: Token does not have whatsapp_business_management scope '
        + 'or no WABA accounts found. User may not have the required permissions.'
      );
      return undefined;
    }
  } catch (error: any) {
    const axiosError = error;
    
    if (axiosError.response) {
      const status = axiosError.response.status;
      const errorData: any = axiosError.response.data;
      
      console.error(
        `getWabasFromDebugToken: API Error (${status}):`,
        errorData?.error?.message || errorData?.message || 'Unknown error'
      );
      
      // Log specific OAuth errors from Facebook
      if (errorData?.error?.code === 100) {
        console.error(
          'OAuth Error #100: Invalid or missing access token. '
          + 'This usually means the SYSTEM_USER_ACCESS_TOKEN is not configured '
          + 'or the user token is invalid.'
        );
      }
    } else if (axiosError.request) {
      console.error('getWabasFromDebugToken: No response received from server');
    } else {
      console.error('getWabasFromDebugToken: Error setting up request:', axiosError.message);
    }
    
    // Re-throw to allow upper layers to handle
    throw error;
  }
};

export { getWabasFromDebugToken };
